var app = angular.module('leonardo');

var MakeReadyFilters = function (
  $scope,
  $filter,
  $controller,
  UnitTypeService,
  WorkFlowService,
  PropertyService,
  TaskService,
  PermissionService,
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.filters_options = [
    {
      id: 'task_name',
      name: 'Task Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Task name',
      condition: true,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'building_number',
      name: 'Building Number',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Building number',
      condition: true,
      options: PropertyService.getBuildings($scope.filterService.getFilter('property')),
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'workflow_type',
      name: 'Workflow Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Workflow type',
      condition: true,
      options: [
        { id: 1, name: $filter('translate')('Move In') },
        { id: 2, name: $filter('translate')('Pre Move Out') },
        { id: 3, name: $filter('translate')('Move Out') },
        { id: 4, name: $filter('translate')('Make Ready') }
      ],
      conflicts: []
    },
    {
      id: 'workflow',
      name: 'Workflow',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Select workflow',
      condition: true,
      service: WorkFlowService,
      conflicts: []
    },
    {
      id: 'unit_type',
      name: 'Unit Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Select unit type',
      condition: true,
      service: UnitTypeService,
      serviceParams: { property: $scope.filterService.getFilter('property') },
      conflicts: ['unit']
    },
    {
      id: 'mrb_status',
      name: 'Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All status',
      condition: true,
      options: TaskService.MRB_STATUS_OPTIONS,
      conflicts: []
    },
    {
      id: 'role',
      name: 'Role',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      options: $scope.authDataService.getRolesValid(),
      condition: PermissionService.isOwner(),
      conflicts: []
    },
    {
      id: 'units_on_notice',
      name: 'Units on Notice',
      type: 'checkbox',
      condition: true
    },
    {
      id: 'overdue_units',
      name: 'Overdue Units',
      label: null,
      inline: false,
      placeholder: 'Overdue Units',
      condition: true,
      type: 'options',
      options: [
        { id: 1, name: $filter('translate')('Turn > 5 days') },
        { id: 2, name: $filter('translate')('Turn < 5 days') }
      ]
    }
  ];

  let filters = $scope.filterService.hasFilter('filters') ? $scope.filterService.getFilter('filters') : [];

  if (!angular.isArray(filters)) {
    filters = filters.split(',');
  }

  $scope.$watch('property', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      PropertyService.getBuildings(newValue).then(function (data) {
        $scope.filters_options[1].options = data.results;
      });
      $scope.filters_options[4].serviceParams = { property: newValue };
    }
  });

  $scope.filterService.setFilter('filters', filters, true);
};

app.controller('MakeReadyFilters', [
  '$scope',
  '$filter',
  '$controller',
  'UnitTypeService',
  'WorkFlowService',
  'PropertyService',
  'TaskService',
  'PermissionService',
  MakeReadyFilters
]);
